import { render } from "./AppButton.vue?vue&type=template&id=8f5418b2&scoped=true&ts=true"
import script from "./AppButton.vue?vue&type=script&lang=ts"
export * from "./AppButton.vue?vue&type=script&lang=ts"

import "./AppButton.vue?vue&type=style&index=0&id=8f5418b2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f5418b2"]])

export default __exports__